"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const ColumnConfig_1 = tslib_1.__importDefault(require("../column-config/ColumnConfig"));
const CheckBoxColumnConfigManager_1 = tslib_1.__importDefault(require("./CheckBoxColumnConfigManager"));
class CheckBoxColumnConfig extends ColumnConfig_1.default {
    constructor(text, mapFieldToSelected, hasHeaderCheckbox, sortable) {
        super("", "th-checkbox", mapFieldToSelected, sortable);
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.checkBoxManager = new CheckBoxColumnConfigManager_1.default();
        if (hasHeaderCheckbox) {
            this.headerCheckbox = new fmko_ts_widgets_1.Checkbox(true);
            this.heading = this.headerCheckbox;
            this.headerCheckbox.addValueChangeHandler(handler => {
                const value = handler.getValue();
                this.checkBoxManager.setHeaderCheckbox(value);
            });
            this.checkBoxManager.addValueChangeHandler(handler => {
                const value = handler.getValue();
                if (hasHeaderCheckbox) {
                    // Set value of selected
                    this.headerCheckbox.setValue(this.checkBoxManager.areAllCheckboxesSelected(), false);
                }
                this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value));
            });
        }
        this.renderer = {
            canRender: (o) => {
                return true;
            },
            postRender: () => {
                if (hasHeaderCheckbox) {
                    this.headerCheckbox.setValue(this.checkBoxManager.areAllCheckboxesSelected(), false);
                }
                this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.checkBoxManager.getSelected()));
            },
            render: (ctx, obj) => {
                let checkBox = this.checkBoxManager.get(obj.data);
                if (!checkBox) {
                    const input = new fmko_ts_widgets_1.Input();
                    checkBox = new fmko_ts_widgets_1.CheckboxWrapper(input.element);
                    this.checkBoxManager.add(obj.data, checkBox);
                    fmko_ts_common_1.Tooltip.fromString(checkBox, text);
                    if (obj.selected) {
                        this.checkBoxManager.click(checkBox);
                    }
                }
                ctx.setWidget(checkBox);
            }
        };
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    getData(data) {
        return { data: data, selected: !!this.mapDataToTD(data) };
    }
    getCheckbox(data) {
        return this.checkBoxManager.get(data);
    }
    getSortableData(data) {
        return this.checkBoxManager.getSelected().includes(data) ? "-1" : "1";
    }
    isSortable() {
        return false;
    }
    getChecked() {
        return this.checkBoxManager.getSelected();
    }
    clear() {
        this.checkBoxManager.clear();
        this.fireEvent(new fmko_ts_common_1.ValueChangeEvent([]));
    }
}
exports.default = CheckBoxColumnConfig;
//# sourceMappingURL=CheckBoxColumnConfig.js.map